import dayjs from "dayjs";
import RateDto from "../../dto/Rate/RateDto";
import { BitrixCompanyDataConverter, BitrixCompanyModel } from "../Dictionaries/BitrixCompanyModel";

type RateModel = Omit<RateDto, "dateUpdatedAt" | "dateValidFrom" | "dateValidTo" | "bitrixCompanyInfo"> & {
  dateUpdatedAt: dayjs.Dayjs;
  dateValidFrom: dayjs.Dayjs;
  dateValidTo: dayjs.Dayjs;
  bitrixCompanyInfo: BitrixCompanyModel;
};

export default RateModel;

export class RateDataConverter {
  static convertRate(rate: RateDto): RateModel {
    return {
      ...rate,
      dateUpdatedAt: dayjs(rate.dateUpdatedAt),
      dateValidFrom: dayjs(rate.dateValidFrom),
      dateValidTo: dayjs(rate.dateValidTo),
      bitrixCompanyInfo: BitrixCompanyDataConverter.convertContractor(rate.bitrixCompanyInfo),
    };
  }

  static convertRates(rates: Array<RateDto>): Array<RateModel> {
    return rates.map((x) => this.convertRate(x));
  }
}
